import React, { useState } from "react";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormHelperText, InputLabel, OutlinedInput, Select, TextField } from "@mui/material";
import { CountryCodes, getByCode } from "../../../../constants/CountryCodes";
import { DatePicker } from "@mui/x-date-pickers";
import { formatDate } from "../../../../utilities/formatters";
import { preventDialogBackdropClick } from "../../../../utilities/generators";
import MenuItem from "@mui/material/MenuItem";
import dayjs from "dayjs";

function QualificationFormDialog(props) {
    return (
        <Dialog
            open={!!props.open}
            onClose={preventDialogBackdropClick(props.onClose)}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>{props.formTitle}</DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    <FormControl
                        component="div"
                        margin="normal"
                        fullWidth
                        required
                        error={!props.title}
                    >
                        <InputLabel id="label-title" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                            Qualification
                        </InputLabel>
                        <OutlinedInput
                            id="text-title"
                            placeholder="Qualification"
                            autoFocus
                            value={props.title}
                            onChange={({target}) => props.setTitle(target.value)}
                            inputProps={{ maxLength: 250 }}
                        />
                        <FormHelperText>Up to 250 characters</FormHelperText>
                    </FormControl>

                    <Box className="flex-container">
                        <FormControl
                            component="div"
                            margin="normal"
                            fullWidth
                            required
                            error={!props.dateAchieved}
                        >
                            <DatePicker
                                id="date-start"
                                label="Achieved"
                                disableFuture
                                format="DD/MM/YYYY"
                                value={dayjs(props.dateAchieved)}
                                onChange={props.setDateAchieved}
                                renderInput={(params) => <TextField {...params} />}
                                maxDate={dayjs()}
                            />
                            <FormHelperText>Date achieved</FormHelperText>
                        </FormControl>

                        <FormGroup>
                            <FormControlLabel
                                label="Primary qualification"
                                control={
                                    <Checkbox
                                        value={!!props.isPrimary}
                                        checked={!!props.isPrimary}
                                        onChange={(e, checked) => props.setPrimary(checked)}
                                    />
                                }
                            />
                        </FormGroup>
                    </Box>

                    <FormControl
                        component="div"
                        margin="normal"
                        fullWidth
                    >
                        <InputLabel id="label-country" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                            Country
                        </InputLabel>
                        <Select
                            id="select-country"
                            value={props.country.code || ""}
                            onChange={({target}) => props.setCountry(getByCode(target.value))}
                        >
                            {CountryCodes?.length > 0 && CountryCodes.map((country) => (
                                <MenuItem key={country.alpha3} value={country.alpha3}>
                                    {country.name}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>Select country</FormHelperText>
                    </FormControl>

                    <FormControl
                        component="div"
                        margin="normal"
                        fullWidth
                    >
                        <InputLabel id="label-content" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                            Notes
                        </InputLabel>
                        <OutlinedInput
                            id="text-notes"
                            placeholder="Notes"
                            multiline
                            rows={4}
                            value={props.notes}
                            onChange={({target}) => props.setNotes(target.value)}
                        />
                        <FormHelperText>Add text here</FormHelperText>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={props.onClose}>
                    Cancel
                </Button>
                <Button
                    key="save"
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={props.onSubmit}
                    disabled={!props.title || !props.dateAchieved}
                >
                    {props.submitLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function QualificationFormContainer({formTitle, submitLabel = "Save", onSave, onClose, data = {}, ...props}) {
    const [title, setTitle] = useState(data.title || "");
    const [dateAchieved, setDateAchieved] = useState(data.dateAchieved || "");
    const [country, setCountry] = useState(data.country || "");
    const [isPrimary, setPrimary] = useState(!!data.isPrimary);
    const [notes, setNotes] = useState(data.notes || "");

    const onSubmit = () => {
        onSave({
            title,
            dateAchieved: formatDate(dateAchieved),
            country,
            isPrimary,
            notes,
        });
        onClose();
    };

    return (
        <QualificationFormDialog
            formTitle={formTitle}
            title={title}
            setTitle={setTitle}
            dateAchieved={dateAchieved}
            setDateAchieved={setDateAchieved}
            country={country}
            setCountry={setCountry}
            isPrimary={isPrimary}
            setPrimary={setPrimary}
            notes={notes}
            setNotes={setNotes}
            onSubmit={onSubmit}
            onClose={onClose}
            submitLabel={submitLabel}
            {...props}
        />
    );
}

export default QualificationFormContainer;
